import React, { PureComponent } from 'react';
import { Loader } from 'react-loaders';

import { batchRequest } from '../../../../api/ApiService';
import Auth from '../../../../routes/Auth';
import { isSurveyFinished } from '../../../../api/Surveys';

import {
  Wrapper,
  PreTitle,
  Title,
  Text
} from '../../components/ui';

import AssessmentChart from '../../components/assessment-chart';

class SelfAssessment extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      chartData: []
    };
  }

  componentDidMount() {
    const { surveys } = this.props;
    const receiverId = Auth.getUserId();
    const finishedSurveys =
      surveys && surveys.length > 0
        ? surveys.filter(i => isSurveyFinished(i))
        : [];

    const lastSurvey =
      finishedSurveys.length > 0
        ? finishedSurveys[finishedSurveys.length - 1]
        : null;

    const lastSurveyId = lastSurvey ? lastSurvey.id : 0;

    const selfAssessmentQuestions = lastSurvey
      ? lastSurvey.questions.filter(
        i => i.category === 'self_assessment'
          && i.assessment_type === 'bars'
          && i.answer_type === 'rating'
      )
      : [];

    if (!lastSurveyId) {
      return this.setState({
        loaded: true
      });
    }

    batchRequest([
      `${process.env.REACT_APP_API_URL}v2/forms/score/${receiverId}/${lastSurveyId}/`,
      ...(selfAssessmentQuestions.length > 0 ? [`${process.env.REACT_APP_API_URL}v2/forms/answers/`] : []),
    ]).then(res => {
      const surveyScore = res[0].body;

      let selfAnswers = [];
      let selfAssessmentAverage = null;
      if (selfAssessmentQuestions.length > 0) {
        const formsAnswers = res[1].body;
        const selfAssessmentQuestionsIds = selfAssessmentQuestions.map(question => question.id);
        selfAnswers = formsAnswers.filter(answer => selfAssessmentQuestionsIds.includes(answer.survey_question));
        selfAssessmentAverage = selfAnswers.reduce((total, next) => total + Number(next.text), 0) / selfAnswers.length;
      }

      let chartData = surveyScore && surveyScore.user_score_question ? surveyScore.user_score_question.map(userQuestion => {
        const currentSelfAssessmentQuestion = selfAssessmentQuestions.find(selfAssessmentQuestion => selfAssessmentQuestion.text.includes(userQuestion.question));
        const currentFormAnswer = currentSelfAssessmentQuestion
          ? selfAnswers.find(answer => answer.survey_question === currentSelfAssessmentQuestion.id)
          : null;
        const currentSelfAssessmentValue = currentFormAnswer ? currentFormAnswer.text : null;

        return {
          question: userQuestion.question,
          "Team-Assessment": userQuestion.median,
          "Self-Assessment": currentSelfAssessmentValue !== null ? Number(currentSelfAssessmentValue) : null,
        }
      }) : [];

      chartData.push({
        question: 'Overall',
        "Team-Assessment": surveyScore.median_user_score,
        "Self-Assessment": Math.round(selfAssessmentAverage * 100) / 100,
      });

      this.setState({
        loaded: true,
        chartData: chartData.filter(i => i['Self-Assessment'] !== null),
      });
    })
      .catch(err => { console.log(err); });
  }

  render() {
    const {
      loaded,
      chartData
    } = this.state;

    return loaded ? (
      <Wrapper>
        <PreTitle>Overview</PreTitle>
        <Title>Self-Assessment</Title>
        <Text>
          <p>Let’s start with a snapshot of how you evaluate your teamwork skills in relation to your team’s evaluation.  Overall, you rated yourself {chartData.length ? chartData.at(-1)['Self-Assessment'] : 0} out of 5 whereas your team gave you a {chartData.length ? chartData.at(-1)['Team-Assessment'] : 0} rating (i.e. your peer rating score).</p>
          <p>Please also review your self assessment on each of the following categories below.</p>
        </Text>
        <AssessmentChart data={chartData} />
      </Wrapper>
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default SelfAssessment;



// WEBPACK FOOTER //
// ./src/components/peer-feedback/pages/overview/self-assessment.js